import React, { useState } from 'react'
import { XAxis, YAxis, VerticalBarSeries, LabelSeries } from 'react-vis'
import {
  XYPlot,
  HorizontalGridLines
} from 'react-vis'

import axiosClient from '../../../libs/axios_client'

const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
]

// Generate array of years (e.g., from 1900 to current year)
const years = Array.from(
  { length: new Date().getFullYear() - 2006 + 1 },
  (_, index) => 2007 + index
);

function getDateFromGermanMonthAndYear(monthName, year) {
  // Monatsnamen auf Deutsch
  const months = {
    'januar': 0, 'februar': 1, 'märz': 2, 'april': 3, 'mai': 4, 'juni': 5,
    'juli': 6, 'august': 7, 'september': 8, 'oktober': 9, 'november': 10, 'dezember': 11
  };

  // Monatsname in Kleinbuchstaben umwandeln und Monatsnummer holen
  const monthIndex = months[monthName.toLowerCase()];
  
  // Prüfen, ob der Monat gültig ist
  if (monthIndex === undefined) {
    throw new Error('Ungültiger Monatsname');
  }

  // Date-Objekt erstellen (Tag auf 15 setzen)
  return new Date(year, monthIndex, 15);
}

export default class HuettenStatistik extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedDate: this.props.date,
      booking_list: this.props.booking_list,
      booking_list_year: this.props.booking_list_year,
      current_huette: this.props.current_huette,
      selectedMonth: monthNames[new Date(this.props.date).getMonth()],
      selectedYear: new Date(this.props.date).getYear()+1900,
      dataMode: 'monthly',
      dataArray: [],
      yMax: 40
    }

    this.setDate = this.setDate.bind(this)
    this.changeDate = this.changeDate.bind(this)
    this.setOverviewMonth = this.setOverviewMonth.bind(this)
    this.setOverviewYear = this.setOverviewYear.bind(this)
  }

  setDate() {
    this.setState({
      selectedDate: getDateFromGermanMonthAndYear(this.state.selectedMonth, this.state.selectedYear)
    })
    this.changeDate(getDateFromGermanMonthAndYear(this.state.selectedMonth, this.state.selectedYear))
  }

  setOverviewMonth() {
    this.setState({
      dataMode:  'monthly',
      yMax: 40
    })
    this.forceUpdate()
  }

  setOverviewYear() {
    this.setState({
      dataMode:  'yearly',
      yMax: 400
    })
    this.forceUpdate()
  }

  render() {
    var dataArray = []
    const Chart = () => {
      if (this.state.dataMode == 'monthly') {
        var booking = this.state.booking_list
        for(var i in booking) {
          dataArray.push({x: i.substring(5,10), y: booking[i], label: booking[i], style: {fontSize: 11, fontFamily: "Helvetica"}})
        }
      } else if (this.state.dataMode == 'yearly') {
        var booking = this.state.booking_list_year
        for(var i in booking) {
          dataArray.push({x: i, y: booking[i], label: booking[i], style: {fontSize: 11, fontFamily: "Helvetica"}})
        }

      }

      return (
        <div>
          <div className='is-flex'>
            <div className='select is-info'>
              <select value={this.state.selectedMonth} onChange={e => this.setState({ selectedMonth: e.target.value }, () => {this.changeDate(getDateFromGermanMonthAndYear(this.state.selectedMonth, this.state.selectedYear))})}>
                <option value="Januar">Januar</option>
                <option value="Februar">Februar</option>
                <option value="März">März</option>
                <option value="April">April</option>
                <option value="Mai">Mai</option>
                <option value="Juni">Juni</option>
                <option value="Juli">Juli</option>
                <option value="August">August</option>
                <option value="September">September</option>
                <option value="Oktober">Oktober</option>
                <option value="November">November</option>
                <option value="Dezember">Dezember</option>
              </select>
            </div>
            <div className='select is-info ml-3'>
              <select value={this.state.selectedYear} onChange={e => this.setState({ selectedYear: e.target.value }, () => {this.changeDate(getDateFromGermanMonthAndYear(this.state.selectedMonth, this.state.selectedYear))})}>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
              ))}
              </select>
            </div>
          </div>
          <div className='is-flex mt-3 mb-5'>
            <button className='button is-info' onClick={this.setOverviewMonth}>Monatsübersicht</button>
            <button className='button is-info ml-3' onClick={this.setOverviewYear}>Jahresübersicht</button>
          </div>
          {/*<p>{this.state.selectedMonth} {this.state.selectedYear}</p>*/}
          <XYPlot
            xType='ordinal'
            height={700}
            width={1184}
            yDomain={[0, this.state.yMax]}>
            <HorizontalGridLines />
            <XAxis
              attr='x'
              attrAxis='y'
              orientation='bottom'
              tickLabelAngle= {this.state.dataMode == 'monthly' ? 0:0}
              position='middle'
              title='' />
            <YAxis
              attr='y'
              attrAxis='x'
              orientation='left'
              position='end'
              title='Anzahl' />
            <VerticalBarSeries
              data={dataArray}
              color='#18748b'
              opacity={0.5}
            />
            <LabelSeries
              animation
              data={dataArray}
            />
          </XYPlot>
          {/*<XYPlot
            xType='ordinal'
            height={700}
            width={1184}
            yDomain={[0, 200]}>
            <HorizontalGridLines />
            <XAxis
              attr='x'
              attrAxis='y'
              orientation='bottom'
              position='end'
              title='Monat' />
            <YAxis
              attr='y'
              attrAxis='x'
              orientation='left'
              position='end'
              title='Anzahl' />
            <VerticalBarSeries
              data={dataArrYear}
              color='#18748b'
              opacity={0.5}
            />
            <LabelSeries
              animation
              data={dataArrYear}
            />
          </XYPlot>*/}
        </div>
      )
    }

    return (
      <div className='huetten-statistik'>
        <Chart />
      </div>
    )
  }

  // ------------
  // change date 
  // ------------
  changeDate(date) {
    // console.log('changeDate: ', date)
    const huette_id = this.props.current_huette_id
    axiosClient.post('/reservierungen/change_date_statistik', {
      date: date,
      huette_id: huette_id
    })
    .then((response) => {
      // console.log('Response: '+JSON.stringify(response))
      // console.log('Belegung: '+JSON.stringify(answer))
      // console.log('Anzahl: '+JSON.stringify(booking_year))
      this.setState({
        current_huette: response.data.huette,
        booking_list: response.data.booking_list,
        booking_list_year: response.data.booking_list_year,
        selectedDate: response.data.date})
    })
  }
}
